import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import '../Style/App.css';
import { API_URL } from '../config/api';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const emailFromUrl = params.get('email') || '';
  
  const [values, setValues] = useState({
    email: emailFromUrl,
    code: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  axios.defaults.withCredentials = true;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    // Validate passwords match
    if (values.newPassword !== values.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    // Validate password requirements
    if (values.newPassword.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }
    if (!/[A-Z]/.test(values.newPassword)) {
      setError('Password must contain at least one uppercase letter');
      return;
    }
    if (!/[a-z]/.test(values.newPassword)) {
      setError('Password must contain at least one lowercase letter');
      return;
    }
    if (!/\d/.test(values.newPassword)) {
      setError('Password must contain at least one number');
      return;
    }
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(values.newPassword)) {
      setError('Password must contain at least one special character');
      return;
    }
    
    setLoading(true);
    
    try {
      const res = await axios.post(
        `${API_URL}/auth/reset-password`,
        {
          email: values.email,
          code: values.code,
          newPassword: values.newPassword
        },
        { withCredentials: true }
      );
      
      if (res.data.ok) {
        setSuccess(true);
        // Redirect to login page after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    });
  };

  if (success) {
    return (
      <div className="loginPage">
        <img
          src="/GradyStar.png"
          alt="Logo"
          className="logo"
        />
        <div className="loginForm">
          <h2 className="text-center"><strong>Password Reset Successful</strong></h2>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <p style={{ color: '#28a745', marginBottom: '10px' }}>
               Your password has been reset successfully!
            </p>
            <p style={{ fontSize: '14px', color: '#666' }}>
              You can now sign in with your new password.
            </p>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Redirecting to login page...
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Link 
              to="/login"
              style={{ color: '#0b3f1f', textDecoration: 'none' }}
            >
              Continue to Sign In →
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="loginPage">
      <img
        src="/GradyStar.png"
        alt="Logo"
        className="logo"
      />
      <div className="loginForm">
        {error && <div className="text-danger mb-2">{error}</div>}
        <h2 className="text-center"><strong>Reset Password</strong></h2>
        <p style={{ textAlign: 'center', marginBottom: '20px', fontSize: '14px', color: '#666' }}>
          Enter the code sent to your email and your new password.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div style={{textAlign: "left", marginBottom: "10px"}}>
            <label style={{display: "block", marginBottom: "5px"}}><strong>Email:</strong></label>
            <input
              type="email"
              name="email"
              className="modern-input"
              value={values.email}
              onChange={handleChange}
              placeholder="Enter your email address"
              required
              disabled={loading}
            />
          </div>
          
          <div style={{textAlign: "left", marginBottom: "10px"}}>
            <label style={{display: "block", marginBottom: "5px"}}><strong>Reset Code:</strong></label>
            <input
              type="text"
              name="code"
              className="modern-input"
              value={values.code}
              onChange={handleChange}
              placeholder="Enter the code from your email"
              required
              disabled={loading}
            />
          </div>
          
          <div style={{textAlign: "left", marginBottom: "10px"}}>
            <label style={{display: "block", marginBottom: "5px"}}><strong>New Password:</strong></label>
            <div style={{position: "relative"}}>
              <input
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                className="modern-input"
                value={values.newPassword}
                onChange={handleChange}
                placeholder="Enter your new password"
                required
                disabled={loading}
                style={{paddingRight: "45px"}}
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="password-toggle-btn"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#666",
                  padding: "2px 6px",
                  width: "auto",
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                title={showNewPassword ? "Hide password" : "Show password"}
                disabled={loading}
              >
                {showNewPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          
          <div style={{textAlign: "left", marginBottom: "15px"}}>
            <label style={{display: "block", marginBottom: "5px"}}><strong>Confirm New Password:</strong></label>
            <div style={{position: "relative"}}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                className="modern-input"
                value={values.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm your new password"
                required
                disabled={loading}
                style={{paddingRight: "45px"}}
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="password-toggle-btn"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#666",
                  padding: "2px 6px",
                  width: "auto",
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                title={showConfirmPassword ? "Hide password" : "Show password"}
                disabled={loading}
              >
                {showConfirmPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          
          <button 
            className="modern-btn" 
            type="submit"
            disabled={loading}
            style={{ opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
          
          <div style={{marginTop: "15px", textAlign: "center"}}>
            <p style={{fontSize: "14px", margin: "0"}}>
              Remember your password? <Link to="/login" style={{color: "#0b3f1f"}}>Sign In</Link>
            </p>
            <p style={{fontSize: "14px", margin: "5px 0 0 0"}}>
              Need a new code? <Link to="/forgot-password" style={{color: "#0b3f1f"}}>Request New Code</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
